export enum AgentRoutingMethod {
  LongestIdleTime = 0,
}
